export default ({store}, inject) => {
    const checkACL = (rolesHaveAccess) => {
        let userRoles = store.state.auth.user.roles;

        for (let role of userRoles) {
            if (rolesHaveAccess.includes(role)) return true;
        }
        return false;
    }
    // Inject $checkACL(rolesHaveAccess) in Vue, context and store.
    inject('checkACL', checkACL)
    // For Nuxt <= 2.12, also add 👇
    // context.$checkACL = checkACL
}